(() => {
  'use strict';
  const q = (s, el = document) => el.querySelector(s);
  const qa = (s, el = document) => [...el.querySelectorAll(s)];
  const el = (tag, text, cls) => { const n = document.createElement(tag); if (text != null) n.textContent = text; if (cls) n.className = cls; return n; };
  // Delegation keeps tabs working when Shopify refreshes a section in the editor.
  const activateTab = tab => {
    const group = tab.closest('[data-tabs]');
    if (!group) return;
    qa('[role="tab"]', group).forEach(t => {
      const active = t === tab;
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
  };
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-tabs] [role="tab"]');
    if (tab) activateTab(tab);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-tabs] [role="tab"]');
    if (!tab) return;
    const tabs = qa('[role="tab"]', tab.closest('[data-tabs]'));
    const index = tabs.indexOf(tab);
    const vertical = tab.closest('[role="tablist"]')?.getAttribute('aria-orientation') === 'vertical';
    let next;
    if (event.key === (vertical ? 'ArrowDown' : 'ArrowRight')) next = (index + 1) % tabs.length;
    else if (event.key === (vertical ? 'ArrowUp' : 'ArrowLeft')) next = (index + tabs.length - 1) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    if (next != null) { event.preventDefault(); activateTab(tabs[next]); tabs[next].focus(); }
  });
  const commerce = window.KPCommerce;
  if (!commerce) return;
  const { money, unitMoney, units, openDialog, refreshCart } = commerce;

  function readProduct(card) {
    try { return JSON.parse(q('[data-quick-product]', card)?.textContent || '{}'); }
    catch { return {}; }
  }
  qa('[data-product-card]').forEach(card => {
    const product = readProduct(card);
    const variant = product.variants?.find(v => v.available) || product.variants?.[0];
    const unit = variant && units(variant, product.handle);
    if (unit) q('[data-card-unit]', card).textContent = `${unitMoney(variant.price / unit.count)} / ${unit.unit}`;
  });

  const drawer = q('#kp-quick-shop');
  const form = q('[data-quick-form]', drawer);
  let current, chosen, busy = false;
  function choose(variant) {
    chosen = variant;
    q('[data-quick-price]', drawer).textContent = variant ? money(variant.price) : 'Unavailable';
    const unit = variant && units(variant, current.handle);
    q('[data-quick-unit]', drawer).textContent = unit ? `${unitMoney(variant.price / unit.count)} / ${unit.unit}` : '';
    q('[data-quick-stock]', drawer).textContent = variant?.available ? 'Available to order' : 'Sold out';
    q('[data-quick-add]', drawer).disabled = busy || !variant?.available;
    q('[data-quick-add]', drawer).firstChild.textContent = busy ? 'Adding… ' : variant?.available ? 'Add to bag ' : 'Sold out ';
    q('[data-quick-link]', drawer).href = current.url + (variant ? `?variant=${variant.id}` : '');
    qa('select[data-quick-option]', drawer).forEach(select => {
      select.value = variant?.options[Number(select.dataset.quickOption)] || select.value;
    });
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-quick-shop]');
    if (!trigger || busy) return;
    const card = trigger.closest('[data-product-card]');
    const product = readProduct(card);
    if (!product.variants?.length) return;
    event.preventDefault(); current = product;
    q('[data-quick-title]', drawer).textContent = product.title;
    q('[data-quick-family]', drawer).textContent = product.family;
    q('[data-quick-error]', drawer).hidden = true;
    form.reset();
    const source = q('.kp-card__image img', card);
    const image = q('[data-quick-image]', drawer);
    image.src = source.currentSrc || source.src; image.alt = product.title;
    image.dataset.kpImageHandle = product.handle; image.dataset.kpImageIndex = '1';
    const options = q('[data-quick-options]', drawer); options.replaceChildren();
    product.options.forEach((name, index) => {
      const values = [...new Set(product.variants.map(v => v.options[index]))];
      const label = el('label', null, 'kp-quick-option');
      label.append(el('span', name === 'Quantity' || name === 'Count' ? 'Pack size' : name === 'Strength' ? 'Strength label' : name));
      if (values.length === 1) label.append(el('strong', values[0]));
      else {
        const select = el('select'); select.dataset.quickOption = index; select.name = `option-${index}`;
        values.forEach(value => {
          const option = el('option', value); option.value = value;
          option.disabled = !product.variants.some(v => v.available && v.options[index] === value);
          select.append(option);
        });
        select.addEventListener('change', () => {
          const desired = [...chosen.options]; desired[index] = select.value;
          const matching = product.variants.find(v => v.options.every((value, i) => value === desired[i]));
          choose(matching || product.variants.find(v => v.available && v.options[index] === select.value));
          q('[data-quick-error]', drawer).hidden = true;
        });
        label.append(select);
      }
      options.append(label);
    });
    choose(product.variants.find(v => v.available) || product.variants[0]);
    openDialog('kp-quick-shop');
  });
  form?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !chosen?.available || !form.reportValidity()) return;
    busy = true; choose(chosen);
    const error = q('[data-quick-error]', drawer); error.hidden = true;
    try {
      const response = await fetch(`${window.KP.root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: chosen.id, quantity: Number(form.elements.quantity.value) })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added. Please try again.');
      try { await refreshCart(); openDialog('kp-cart'); }
      catch { location.assign(`${window.KP.root}cart`); }
    } catch (reason) { error.textContent = reason.message; error.hidden = false; }
    finally { busy = false; choose(chosen); }
  });

  // Keep the prominent search entry focused when its dialog opens.
  qa('[data-open="kp-search"]').forEach(button => button.addEventListener('click', () => q('[data-predictive-input]')?.focus()));
  // FAQ answers retain native details behavior and work without JavaScript.
})();
